import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiCvPhotoGeneratorConfig } from '@/data/landingConfig/landingAiCvPhotoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiCvPhotoGenerator } from './schemaObject';

interface Props {}
const AiCvPhotoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiCvPhotoGenerator} />
			<LandingTemplate
				data={landingAiCvPhotoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default AiCvPhotoGenerator;
